import React from "react";
import "./HeaderHome.css";

const baseURL = "https://maxscholars.org/static-images/headers";

function HeaderHome({ backgroundUrl }) {
  // Photo dimensions 500H x 1500W work well
  return (
    <div className="header-container">
      <img className="header-photo" src={baseURL + "/" + backgroundUrl} alt=""></img>
    </div>
  );
}

export default HeaderHome;
